const routes = [
    {
        path: "/yoksis/units",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "yoksisunit_index"
        }
    },
];

export default routes;
